var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-detail",class:!_vm.valid && 'invalid'},[(_vm.empty)?_c('div',{staticClass:"detail-title"}):_c('span',{staticClass:"detail-title",domProps:{"innerHTML":_vm._s(`${_vm.label} :`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }